import { useEvent } from "../../../../context/EventContext";

// * SubEventFormPreview is a component that displays all the sub events
// * entered by the user and allows them to edit each sub event or add
// * a new one. It also allows the user to go to the next step of the form.
const SubEventFormPreview = ({ onNext, setIsFormVisible }) => {
  const {
    subEvents,
    setSubEventFormData,
    setSubEventEditIndex,
    mainEventID,
    setSelectedDate,
    setView,
  } = useEvent();

  // * Handles the "Edit" button click for each sub event.
  // * It sets the subEventFormData state to the sub event to be edited and
  // * displays the sub event form. It also sets the subEventEditIndex state to the
  // * index of the sub event to be edited.
  const handleEdit = (index) => {
    const selectedEvent = subEvents[index];
    // Ensure that start and end are Date objects
    const startDate = new Date(selectedEvent.start);
    const endDate = new Date(selectedEvent.end);

    setSubEventFormData({
      ...selectedEvent,
      start: startDate,
      end: endDate,
    });
    // setSubEventFormData(selectedEvent);
    setIsFormVisible(true);
    setSubEventEditIndex(index);
    // Trigger calendar to focus on the event's start date
    setSelectedDate(new Date(selectedEvent.start)); // Set the selected date
    setView("day"); // Switch to day view to display event details
  };

  // * Handles the "Add Sub Event" button click by setting the subEventFormData
  // * state to an empty object with mainEventID, setting the isFormVisible state
  // * to true, and setting the editIndex state to null. This displays the sub
  // * event form.
  const handleSubAdd = () => {
    setSubEventFormData({
      title: "",
      event_type: "",
      location: "",
      start: null,
      end: null,
      description: "",
      speakers: [],
      sponsors: [],
      registration_types: [],
      isOpen: "",
      mainEventID: mainEventID,
    });
    setIsFormVisible(true);
    setSubEventEditIndex(null);
  };

  return (
    <>
      {subEvents?.map((subEvent, index) => (
        <div className="saved-details" key={index}>
          <p>
            <span>Event Name: </span> {subEvent?.title}
          </p>
          <p>
            <span>Is Open For All: </span>
            {subEvent?.isOpen === true ? "YES" : "NO"}
          </p>
          <button className="add-space" onClick={() => handleEdit(index)}>
            Edit
          </button>
        </div>
      ))}
      <div className="buttons-controller">
        <button className="add-space" onClick={() => onNext()}>
          Next
        </button>
        <button className="add-space" onClick={() => handleSubAdd()}>
          Add Another subEvent
        </button>
      </div>
    </>
  );
};

export default SubEventFormPreview;
